import React, { memo } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

const ErrorState = memo(function ErrorState({
  title = 'Failed to load data',
  message = 'An unexpected error occurred while fetching information. Please try again.',
  onRetry,
  style = {},
  className = '',
}) {
  return (
    <div
      className={`error-state-container ${className}`.trim()}
      style={{
        textAlign: 'center',
        padding: '44px 24px',
        background: '#FEF2F2',
        borderRadius: 14,
        border: '1.5px solid #FCA5A5',
        margin: '16px 0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: '50%',
          background: '#FEE2E2',
          color: '#DC2626',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 14,
        }}
      >
        <AlertTriangle size={26} />
      </div>
      <h3
        style={{
          fontFamily: 'var(--font-serif, serif)',
          fontSize: 18,
          fontWeight: 700,
          color: '#991B1B',
          marginBottom: 6,
        }}
      >
        {title}
      </h3>
      <p
        style={{
          fontSize: 13,
          color: '#7F1D1D',
          maxWidth: 420,
          margin: '0 auto 18px',
          lineHeight: 1.5,
        }}
      >
        {message}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            background: '#DC2626',
            color: '#FFFFFF',
            borderRadius: 9,
            padding: '9px 20px',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            border: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            boxShadow: '0 2px 8px rgba(220, 38, 38, 0.2)',
          }}
        >
          <RefreshCw size={15} />
          Retry
        </button>
      )}
    </div>
  );
});

export default ErrorState;
